/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Alignment',
  'company-hub.links-menu-extension.all.borders.label-text': 'All sides',
  'company-hub.links-menu-extension.background.color': 'Background colour',
  'company-hub.links-menu-extension.background.title': 'Background',
  'company-hub.links-menu-extension.border.color': 'Border colour',
  'company-hub.links-menu-extension.border.position': 'Border position',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Bottom border',
  'company-hub.links-menu-extension.center.option': 'Center',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Add important links',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Link',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Group related links together',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'You have reached the maximum number of nested levels.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menu',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Cancel',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Delete',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'This action will delete this item and all nested items.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Delete item',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Add sub item',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Delete item',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Edit properties',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Move down',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Move up',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Open the link',
  'company-hub.links-menu-extension.config-panel.items.label': 'Items',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'You have reached the maximum number of items that can be added to a links menu.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'New item',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Add links and organise them with submenus. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Learn more about links menu',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Add links and organise them with submenus.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Cancel',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Confirm',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Please fill out this field.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Display text',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Item name',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Confirm',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'More',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Styles',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'You have reached the maximum number of items that can be added to a links menu.',
  'company-hub.links-menu-extension.config-panel.title': 'Links menu',
  'company-hub.links-menu-extension.fixed.option': 'Fixed at top',
  'company-hub.links-menu-extension.left.option': 'Left',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'More',
  'company-hub.links-menu-extension.manifest.extension-description': 'Add multiple links and sub-menus to Company Hub',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Links menu',
  'company-hub.links-menu-extension.manifest.extension-title': 'Links menu [New]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'About us',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Team 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Benefits',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Teams',
  'company-hub.links-menu-extension.no.border.label-text': 'None',
  'company-hub.links-menu-extension.right.option': 'Right',
  'company-hub.links-menu-extension.section.collapse.label': 'Collapse section',
  'company-hub.links-menu-extension.section.expand.label': 'Expand section',
  'company-hub.links-menu-extension.selected.state.color': 'Selected state colour',
  'company-hub.links-menu-extension.text.color': 'Text colour',
  'company-hub.links-menu-extension.text.title': 'Text',
};
